import { UserType } from '@/constants';
import { Button, Checkbox, Divider, message } from 'antd';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { SaveOutlined } from '@ant-design/icons';
import { AccessRequirementDto } from '@/__generated';
import { apiSdk } from '@/httpClient';

export default function TowfactorAuthConfiguration() {
  const { t } = useTranslation();
  const [accessRequirements, setAccessRequirements] = React.useState<AccessRequirementDto[]>([]);

  React.useEffect(() => {
    apiSdk.AccessRequirementService.getAccessRequirements().then(res => {
      setAccessRequirements(res);
    });
  }, []);

  const onCheckboxChange = (type: number, checked: boolean) => {
    setAccessRequirements(f => [...f.filter(x => x.userType !== type), { userType: type, twoFactorEnabled: checked }] as any);
  };

  const save = () => {
    apiSdk.AccessRequirementService.update({
      body: {
        accessRequirements: accessRequirements,
      },
    }).then(res => {
      if (res.success) {
        message.success(t('accessControlPage_UpdateSucessMessage'));
      } else {
        message.error(t(res.message || ''));
      }
    });
  };

  return (
    <div style={{ maxWidth: 500 }}>
      <h2>{t('accessControlPage_2faSubtitle')}</h2>
      <Divider />
      <div>
        <Checkbox
          onChange={e => {
            onCheckboxChange(UserType.GlobalUser, e.target.checked);
          }}
          checked={accessRequirements.find(x => x.userType === UserType.GlobalUser)?.twoFactorEnabled}
        >
          {t('accessControlPage_2faGlobalUser')}
        </Checkbox>
      </div>
      <div>
        <Checkbox
          onChange={e => {
            onCheckboxChange(UserType.CompanyUser, e.target.checked);
          }}
          checked={accessRequirements.find(x => x.userType === UserType.CompanyUser)?.twoFactorEnabled}
        >
          {t('accessControlPage_2faCompanyUser')}
        </Checkbox>
      </div>
      <Divider />

      <Button type="primary" htmlType="submit" onClick={save} icon={<SaveOutlined />}>
        {t('save')}
      </Button>
    </div>
  );
}
